import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

/**
 * @type {{"15": string, "30": string, "20": string, "10": string}}
 */
export const PERIODS = {
    10: 'Fixed10Year',
    15: 'Fixed15Year',
    20: 'Fixed20Year',
    30: 'Fixed30Year',
};

export const SOURCE_ZILLOW = 'zillow';

class MortgageRateAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'mortgage-rate';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'mortgages/rates';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'state',
            'rate',
            'date',
            'term',
            'source',
        ];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            state: {
                type: 'string',
                presence: true
            },
            rate: {
                numericality: true,
                presence: true,
            },
            date: {
                datetime: {
                    dateOnly: true
                },
            },
            term: {
                numericality: true,
                presence:  true
            },
            source: {
                type: 'string',
                presence:  true
            }
        };
    }
}

export default MortgageRateAppResource;
